<section class="about" aria-label="about">
  <div class="about-inner">
    <figure class="about-media">
      <img
        class="about-image"
        src="/assets/images/saint_brendan.jpg"
        alt="Saint Brendan the Navigator"
        loading="lazy"
      />
      <figcaption class="image-credit">
        Credit: <a
          href="https://legacyicons.com/saint-brendan-the-voyager-icon-s414/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legacy Icons
        </a>
      </figcaption>
    </figure>

    <div class="about-content">
      <h1 class="about-title">Project Brendan <span class="muted">v{{ version }}</span></h1>

      <p class="about-text">
        Saint Brendan the Navigator is remembered for voyaging into the unknown
        with faith, skill, and a steady hand.
      </p>

      <p class="about-text">
        In the same spirit, Project Brendan is a modular trading framework built for simulation and research, 
        centered on technical indicators, regime-aware strategies, and explainable signals. 
        It makes it easy to understand what drove a decision, validate it with data, and iterate with confidence.
      </p>

      <p class="about-text">
        Project Brendan is still in its early stages, and new capabilities are
        being added regularly. Please check back often for updates as the
        platform continues to grow and evolve.
      </p>      
    </div>
  </div>
</section>